/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ size: NonNullable<unknown> }} Common_Uploader_Max_SizeInputs */

const en_common_uploader_max_size = /** @type {(inputs: Common_Uploader_Max_SizeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Max ${i?.size}MB`)
};

const zh_common_uploader_max_size = /** @type {(inputs: Common_Uploader_Max_SizeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`最大 ${i?.size}MB`)
};

/**
* | output |
* | --- |
* | "Max {size}MB" |
*
* @param {Common_Uploader_Max_SizeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_uploader_max_size = /** @type {((inputs: Common_Uploader_Max_SizeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Uploader_Max_SizeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_uploader_max_size(inputs)
	return zh_common_uploader_max_size(inputs)
});
export { common_uploader_max_size as "common.uploader.max_size" }